import facilityService from "@/api/facilityService";
import menuService from "@/api/MenuService";
import vendorService from '@/api/vendorService'
// import DeviceService from "@/api/device";
// import AppService from '@/api/AppService';
import tenantService from '@/api/tenantService';
import TeamService from "@/api/TeamService";
import driverService from "@/api/driverService";
import vehicleTypeService from "@/api/vehicleTypeService";
// import VehicleService from "@/api/VehicleService";
import BillingService from "@/api/billingService";
import * as signalrService from "@/api/signalrService";
import PwdService from "@/api/pwdService";
// import { VEHICLE_STATUS, getIconByStatus, angleFromCoordinate, latLngFromString, validateCoordinatesAndStatus, formatMarkerProperties } from "@/utils/map/mapUtils";
// import { convertSecondsToDaysHoursMinSecInDigits,convertSignalRDateTimeStamp } from "@/utils/date-helpers";
// import { MAP_MARKER_MOVE_INTERVAL } from "@/utils/constants";
import mapService from "@/api/mapService";
// import { DEFAULT_LOCATION } from '@/utils/map/mapUtils';
// import { delete } from "vuedraggable";
// import billingService from "@/api/billingService";
/* All the global state variables will be put here  */
// import Vue from 'vue';

export const state = {
    settings: {},
    isDrawer: false,
    facilities: [],
    editId: null,
    selectedFacility: null,
    menuItem: [],
    settingMenuItem: [],
    vendors: [],
    employees: [],
    selectedEmployee: null,
    vehicles: [],
    drivers: [],
    devices: [],
    dviceTypes:[],
    fuelType: [],
    sensors: [],
    vehicleTypes: [],
    speedLimit: [],
    userRoles: [],
    users: [],
    vehicleUserMapData: [],
    loader: false,
    vehicleSpeedLimitColors: [],
    sosCount: 0,

    tenantID: '1',
    loginShifts: [],
    logoutShifts: [],
    teams: [],
    newFacility: '',
    tenantData: {},
    name: "",
    EmpTenantData: [

    ],
    EmpData: [],
    billData: [],
    vehicleType: [],
    allowAdhocRequestApproval: null,
    allowFacilitySelection: null,
    allowRolePermissionEdit: null,
    allowTeamSelection: null,
    allowRouting: null,
    showSOS: null,
    showNavigationMenu: '',
    getInitialDataData: null,
    allowEmployeeSelection: null,
    initialEmployee: [],
    BillFilterdData: [],
    link: '',
    allowViewTripPrice: null,
    workspaceBookingApprovalRequired: false,
    autoCreateRosterOnWorkspaceBooking: false,
    isTimeFormat: true, //if it is 24 hours 
    geofencingData: null,
    fileUploadChannelKey:null,
    reportServiceChannelKey:null,
    geofenceChannelKey:null,
    geofencingReport:[],
    geofenceCount:[],
    mapConnectionStatus:"",
    immobilizePermissions:null
    
}


/* All the global getters will be defined here */
export const getters = {
    isDrawer: state => state.isDrawer,
    selectedFacility: state => state.selectedFacility,
    allowedLogoutTimes: state => state.logoutShifts.map(time => {//TODO login logout shifts should come as datetime from db
        let times = time.logoutTime.split(":");
        let date = new Date();
        date.setHours(times[0]);
        date.setMinutes(times[1]);
        return date;
    }),
    allowedLoginTimes: state => state.loginShifts.map(time => {
        let times = time.loginTime.split(":");
        let date = new Date();
        date.setHours(times[0]);
        date.setMinutes(times[1]);
        return date;
    }),
    getDateTimeFormat: (state) => {
        return state.isTimeFormat ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy hh:mm tt'
    },
    getTimeFormat: (state) => {
        console.log('#time getters calling me');
        let val = state.isTimeFormat ? 'HH:mm' : 'hh:mm tt'
        return val
    },
    getVehicleByID: state => (id) => state.vehicles.find(vehicle => vehicle.id == id),
    newFac: state => state.newFacility,
    facility: state => state.facilities,
    getTeam: state => state.teams,
    getEmployee: state => state.EmpData,
    getVehicles: (state) => state.vehicles,
    getSelectVehicle: (state) => (vehicleInfo) => {
        console.log("vehicleInfo", vehicleInfo)
        return state.vehicles
    },
    getInitialData: (state) => {
        if (!state.getInitialDataData) {
            return
        }
        return state.getInitialDataData
    },
    getSignalRUpdatedVehicles: (state) => {
        let val =state.vehicles.filter((vehicle) => vehicle.status != undefined && !!vehicle.dateTime).sort((a, b) => a.rtoNumber - b.rtoNumber);
        return val
    },
    // getGeofencingData: (state) => state.geofencingData,
    // getDrivers: (state) => state.drivers,
    // getSensors: (state) => state.sensors,
    // getDevices: (state) => state.devices,
    // getDeviceTypes: (state) => state.dviceTypes,
    // getTenants: (state) => state.tenants
    // getFuelTypes:(state) => state.fuelType,
    // getVehicleTypes: (state) => state.vehicleTypes,
    // getCenterAndZoom: (state) => {
    //     let center = latLngFromString(state.tenantData.mapDefaultLocation);
    //     if (!center) {
    //         center = DEFAULT_LOCATION;
    //     }
    //     return {
    //         center,
    //         zoom: +state.tenantData.mapZoomLevel,
    //     }
    // },
    // getSpeedLimit: (state) => state.speedLimit,
    // getLoaderStatus: (state) => state.loader,
    // getUsers: (state) => state.users,
    // getUserRoles: (state) => state.userRoles,
    // getVehicleUserMap: (state) => state.vehicleUserMapData,
    // getVehicleSpeedLimitColors: (state) => state.vehicleSpeedLimitColors,
    // getVehicleDeviceIdList: (state) => state.vehicles.filter((vh) => vh.imei),
    // getSosCount: (state) => state.sosCount,
    // getGeofencingReport:(state)=> state.geofencingReport,
    // getMapStateConnections:(state)=> state.mapConnectionStatus,
}

/* All the global actions will be defined here */
export const actions = {
    async loadSettings({ commit }) {
        const data = await fetch('/settings.json');
        const settings = await data.json()
        commit('setSettings', settings);
        return data;
    },
    async loadAllFacilities({ commit }) {
        const { data } = await facilityService.getFacility();
        commit('setAllFacilities', data);
        commit('setSeclectedFacility', data[0]);
    },
    async loadMenu({ commit }) {
        const { data } = await menuService.getMenu();
        commit('setMenu', data);
    },
    async loadSettingMenu({ commit }) {
        const { data } = await menuService.getSettingMenu();
        commit('setSettingMenu', data.result);
    },
    async loadVendors({ commit, state }) {
        let faceID = state.selectedFacility.id
        const { data } = await vendorService.getVendors(faceID);
        commit('setVendors', data.result)
    },
    // async loadInitialData({ commit }) {
    //     const { data } = await AppService.getInitialData();
    //     commit('setInitialData', data);
    // },
    async getTenant({ commit }) {
        const { data } = await tenantService.getTenant()
        commit('setTenantdata', data.result);
    },
    async getTenantEmp({ commit }) {
        const { data } = await tenantService.getTenantEmpDetails()
        commit('setTenantEmpdata', data.result);
    },
    async saveTenant({ commit }, data) {
        await tenantService.updateTenant(data.id, data.displayName, {})
        commit('saveTenant', data);
    },
    async loadEmpFromUser({ commit }) {
        let data = await TeamService.getEmpByUser()

        commit('setEmp', data);

    },
    async GetOrgDetails({ commit, state }) {
        let tenantId = state.tenantData.id
        let faceID = state.selectedFacility.id
        //   console.log("state", state)
        let res = await tenantService.geOrgDetails(tenantId, faceID)
        commit('setOrgDetails', res.data);
    },
    async tenantFileUpload({ commit, dispatch, state }, data) {
        let type = 'Tenant'
        let res = await tenantService.fileupload(state.tenantData.id, type, data)
        commit('getFileLink', res.data.result);
        dispatch("updateFile", res.data.result)
    },
    async updateFile({ state }, url) {
        console.log(state, url)
        let name = state.tenantData.displayName
        await tenantService.updateFile(url, name)
    },

    async getDriver({ commit }) {
        let id = state.selectedFacility ? state.selectedFacility.id : null
        const response = await driverService.getDrivers(id);
        commit('getDriver', response.data.result)
    },
    async getBilling({ commit }) {
        const response = await BillingService.getBillingCategory();
        commit('getBilling', response.data)
    },
    async getVehicleType({ commit }) {
        const response = await vendorService.getVehicleType();
        commit('getVehicleType', response.data || [])
    },
    async getAllTeam({ commit, state }) {
        if (!state.selectedFacility) {
            return
        }
        let id = state.selectedFacility ? state.selectedFacility.id : null
        const res = await TeamService.getTeam(id)
        let data = res.data.result
        commit('getAllteam', data)
    },
    async changPwd({ commit }, body) {
        const response = await PwdService.changePwd(body);
        commit('pwdChange');
        return response;
    },
    async getAllVehicleTypes({ commit }) {
        const response = await vehicleTypeService.getVehicleTypesbyTenant();
        commit('allVehicleTypes', response.data || [])
    },
    // async getVehicleExtraDetails({ state, commit, dispatch }, vehicle) {
        
    //     // let locationAddress;
    //     // try {
    //     //     // locationAddress = await VehicleService.getVehicleLocationByLatLong(vehicle.lat, vehicle.lon);
    //     // } catch (error) {
    //     //     console.error('ERROR in getting location from lat long', error)
    //     // }
    //     // let mappedVehicles = [];
    //     if (vehicle) {
    //         vehicle.signalRmodel= vehicle.model;
    //         delete vehicle.model;
    //          //check for vehicle with same deviceid and different coordinates. If same coordinates are present and then same status no need to update
    //         let existingVehicle = state.vehicles.find(v => v.imei == vehicle.deviceid && validateCoordinatesAndStatus(v.lat, v.lng, vehicle.lat, vehicle.lng, v.status, vehicle.status));

    //         if (existingVehicle) {
            
    //             let dir = angleFromCoordinate(existingVehicle.lat, existingVehicle.lng, vehicle.lat, vehicle.lng);
    //             // console.table({ vehicle: existingVehicle.rtoNumber, lat: existingVehicle.lat, lng: existingVehicle.lng, tolat: vehicle.lat, toLng: vehicle.lng, dir });
    //             let updatedVehicle = {
    //                 ...existingVehicle,
    //                 ...vehicle,
    //                 address: vehicle.location, //locationAddress ? locationAddress.data.display_name : '',
    //                 // addressObj: locationAddress ? locationAddress.data : '',
    //                 iconUrl: getIconByStatus(vehicle.status, existingVehicle.type),
    //                 dateTime: convertSignalRDateTimeStamp(vehicle.timestamp),
    //                 duration: MAP_MARKER_MOVE_INTERVAL,
    //                 lastRefreshed: new Date(),
    //                 dir: dir,
    //                 idle: convertSecondsToDaysHoursMinSecInDigits(vehicle.idle),//ehicle.idle),
                    
    //             };
    //         // console.log("obj",updatedVehicle)
    //             updatedVehicle = formatMarkerProperties(updatedVehicle);
    //             dispatch('mapStore/trackVehicles', updatedVehicle);
    //             commit('updateVehicle', updatedVehicle);
    //         }
    //     }



    //     //     mappedVehicles = state.vehicles.map(v => {
    //     //         if (v.imei == vehicle.deviceid && validateCoordinates(v.lat, v.lng, vehicle.lat, vehicle.lng)) {
    //     //             let dir = vehicle.dir;
    //     //             if (!dir) {
    //     //                 dir = angleFromCoordinate(v.lat, v.lng, vehicle.lat, vehicle.lng);
    //     //             }
    //     //             // console.log(v.rtoNumber, dir);
    //     //             // console.table({ vehicle: v.rtoNumber, lat: v.lat, lng: v.lng, tolat: vehicle.lat, toLng: vehicle.lng, dir });
    //     //             // fix for model overriding of vehicle data issue
    //     //             // const signalRModel = vehicle.model;
    //     //             // delete vehicle.model;
    //     //             // vehicle.signalRModel = signalRModel;

    //     //             const obj = {
    //     //                 ...v,
    //     //                 ...vehicle,
    //     //                 address: vehicle.location, //locationAddress ? locationAddress.data.display_name : '',
    //     //                 // addressObj: locationAddress ? locationAddress.data : '',
    //     //                 iconUrl: getIconByStatus(vehicle.status, v.type),
    //     //                 dateTime: convertSignalRTimeStamp(vehicle.timestamp),
    //     //                 duration: MAP_MARKER_MOVE_INTERVAL,
    //     //                 lastRefreshed: new Date(),
    //     //                 dir: dir,
    //     //                 idle: getHoursFromSeconds(vehicle.idle),//ehicle.idle),
    //     //             };
    //     //             dispatch('mapStore/trackVehicles', obj);
    //     //             return obj;
    //     //         } else {
    //     //             return v;
    //     //         }
    //     //     });
    //     // }
    //     // commit("setVehicles", mappedVehicles);
    // },
    async uploadProfile({ commit }, data) {
        await tenantService.updateProfileImage(data);
        commit('notify',)
    },
    // async startConnection({ state }) {
    //     let ids = [];

    //     state.vehicles.forEach(vcl => {
    //         if (vcl.imei && !ids.includes(vcl.imei))
    //             ids.push(vcl.imei);
    //     });
    //     try {
    //         await signalrService.start();
    //         signalrService.setLiveTrackingDataListener("getVehicleExtraDetails");
    //         await signalrService.subscribe(ids);
    //     } catch (err) {
    //         console.log('ERROR WHILE ESTABLISHING CONNECTIONS', ids, err);
    //     }
    // },
    // async addVehicle({ commit }, data) {
    //     commit('addVehicle', { ...data, status: VEHICLE_STATUS.NO_SIGNAL });
    //     if (data.imei)
    //         await signalrService.subscribe([data.imei]);
    // },
    // async updateVehicle({ commit, state }, data) {
    //     console.log('Updating the vehcile ............ ', data.imei, data);
    //     const index = state.vehicles.findIndex(v => v.imei === data.imei);
    //     if (index !== -1 && data.imei) {
    //         try {
    //             await signalrService.subscribe([data.imei]);
    //         } catch (err) {
    //             console.error('Something went wrong while subscribing ', err);
    //         }
    //     }

    //     const vehicleType = state.vehicleTypes.find((vt) => vt.id === data.vehicleType);
    //     const oldVehicleData = state.vehicles.find((v) => v.id === data.id);
    //     const newData = {
    //         ...oldVehicleData,
    //         ...data,
    //         iconUrl: getIconByStatus(oldVehicleData.status, vehicleType.type),
    //         type: vehicleType.type,
    //     }
    //     commit('updateVehicle', newData);
    // },
    async stopConnection() {
        await signalrService.stop();
    },
    async loadGeofencingData({ commit }) {
        const res = await mapService.loadGeofencingData();
        commit("setGeofencingData", res.data.result);
    },

    async getGeofenceCount({commit}){
        const res = await mapService.getGeofenceCount( state.geofenceChannelKey);
        commit("getGeofenceCount", res.data.result);
    },

    async updateMapConnectionStatus({commit},data){
        console.log("#statuslog",data),
        commit("setMapConnectionStatus",data);
    }

}

/* All the global mutations will be listed here */
export const mutations = {
    toggleDrawerClick(state) {
        // console.log('Drawer toggle')
        state.isDrawer = !state.isDrawer
    },
    toggleDrawerClose(state, closeMenu) {
        // console.log('Drawer toggle')
        state.isDrawer = closeMenu
    },
    setAllFacilities(state, facilities) {
        state.facilities = facilities;
    },
    setSeclectedFacility(state, selectedFacility) {
        state.selectedFacility = selectedFacility;
    },
    notify() { },
    setMenu(state, item) {
        state.menuItem = item;
    },
    getFileLink(state, link) {
        console.log('link', link)
    },
    setSettingMenu(state, item) {
        state.settingMenuItem = item;
    },
    setVendors(state, vendor) {
        state.vendors = vendor;
    },
    setInitialData(state, data) {
        state.getInitialDataData = data
        state.sensors = data.sensors;
        state.dviceTypes = data.dviceTypes;
        state.tenants = data.tenants
    },
    // facility page mutation funcions start
    addFacility(state, newFacility) {
        state.facilities.push(newFacility)
    },
    editFacility(state, response) {
        state.editId = response.data.result.id
        state.newFacility = response.data.result
    },
    updateFacility(state, facility) {
        const index = state.facilities.map(item => item.id).indexOf(state.editId)
        state.facilities[index] = facility;
    },
    removeFacility(state, facility) {
        const index = state.facilities.map(item => item.id).indexOf(facility.dataItem.id)

        state.facilities.splice(index, 1)
    },
    // facility page mutation funcions end
    setTenantdata(state, tenantData) {
        state.tenantData
            = tenantData
        state.name = tenantData.displayName
    },
    setTenantEmpdata(state, tenantData) {
        state.EmpTenantData = tenantData

    },

    saveTenant(state, data) {
        state.tenantData = data
        state.name = data.displayName
    },
    getAllteam(state, team) {
        state.team = team

    },
    updateVehicles(state,vehicles){
       
        state.vehicles = state.vehicles.map(v=>{
           let data= vehicles.find(i=>i.imei==v.deviceid)
           if(data){
               return {...v,...data}
           }
         
               return v
        
        })
        console.log("fffff",vehicles)
    },
    setSettings(state, settings) {
        state.settings = settings;
    },
    setEmp(state, data) {
        // console.log("data 1234", data)
        let empData = data.data != 'Data not available' ? data.data : []
        state.EmpData = empData;
    },
    getDriver(state, driver) {

        state.drivers = driver
    },
    setOrgDetails(state, data) {
        let resData = data != 'Data not available' ? data : []
        var result = Object.keys(resData).map(function (key) {

            return { "Key": key, "Value": resData[key] }
        });
        state.EmpTenantData = result

    },
    getBilling(state, data) {
        //  console.log("data", data)
        state.billData = data
    },
    getVehicleType(state, data) {
        // console.log("data", data)
        state.vehicleType = data
    },
    allVehicleTypes(state, vehicleTypes) {
        state.vehicleType = vehicleTypes != 'Data not available' ? vehicleTypes : []
        // state.vehicleType = vehicleTypes
    },
    getBillData(state, value) {

        //console.log("===>",state.billData)
        state.BillFilterdData = state.billData.filter(
            (obj) => obj.billCategory.vehicleTypeID == value
        );
        // console.log("===>",  state.BillFilterdData)
    },
    setSensors(state, values) {
        state.sensors = values;
    },
    setVehicles(state, vehicles) {
        state.vehicles = vehicles;
    },
    addVehicle(state, vehicle) {
        const vehicles = [...state.vehicles];
        vehicles.splice(0, 0, vehicle);
        state.vehicles = vehicles;
    },
    updateVehicle(state, data) {

        // const index = state.vehicles.findIndex(v => v.imei === data.imei);
        // if (index !== -1) {
        //     Vue.set(state.vehicles, index, data);
        // }
        
        const obj = state.vehicles.find((v) => v.id === data.id);
        if (obj) {
            Object.assign(obj, data);
        }
         //state.vehicles = state.vehicles.map(v => v.imei === data.imei ? data : v);
    },
    removeVehicle(state, id) {
        if (!id) return false;
        const index = state.vehicles.findIndex((v) => v.id === id);
        if (index !== -1)
            state.vehicles.splice(index, 1);
    },
    addDriver(state, driver) {
        state.drivers.splice(0, 0, driver);
    },
    updateDriver(state, data) {
        console.log('Updating the Driver..........', data.id, data);
        let index = -1;
        const obj = state.drivers.find((d, i) => {
            if (d.id === data.id) {
                index = i;
                return true;
            }
        });
        if (index === -1) return;
        console.log('Before update Object ', obj)
        const updatedObj = { ...obj, ...data };
        console.log('Consolidated Object : ', updatedObj);
        state.drivers.splice(index, 1, updatedObj);
    },
    removeDriver(state, id) {
        let index = state.drivers.findIndex((d) => d.id === id);
        console.log('REMOVING DRIVER : ', index, state.drivers[index]);
        if (index !== -1)
            state.drivers.splice(index, 1);
    },
    addDevice(state, device) {
        state.devices.splice(0, 0, device);
    },
    updateDevice(state, data) {
        let index = -1;
        const obj = state.devices.find((d, i) => {
            if (d.id === data.id) {
                index = i;
                return true;
            }
        });
        if (index === -1) return false;
        const updatedObj = { ...obj, ...data };
        state.devices.splice(index, 1, updatedObj);
    },
    removeDevice(state, id) {
        let index = state.devices.findIndex((d) => d.deviceid === id);
        console.log("Removing device : ", index, id);
        state.devices.splice(index, 1);
    },
    addSensor(state, sensor) {
        state.sensors.push(sensor);
    },
    updateSensor(state, data) {
        let index = -1;
        const obj = state.sensors.find((s, i) => {
            if (s.id === data.id) {
                index = i;
                return true;
            }
        });
        if (index === -1) return false;
        const updatedObj = { ...obj, ...data };
        state.sensors.splice(index, 1, updatedObj);
    },
    removeSensor(state, id) {
        let index = state.sensors.findIndex((s) => s.id === id);
        state.sensors.splice(index, 1);
    },
    resetSelectionCheckboxes(state, value = false) {
        state.vehicles.map((v) => v.selected = value);
    },
    setGeofencingData(state, data) {
        state.geofencingData = data;
    },
    pwdChange() {

    },
    addVehicleType(state, vType) {
        state.vehicleTypes.push(vType);
    },
    updateVehicleType(state, vType) {
        let index = -1;
        const obj = state.vehicleTypes.find((d, i) => {
            if (d.id === vType.id) {
                index = i;
                return true;
            }
        });
        if (index === -1) return false;
        const updatedObj = { ...obj, ...vType };
        state.vehicleTypes.splice(index, 1, updatedObj);
    },
    removeVehicleType(state, id) {
        let index = state.vehicleTypes.findIndex((s) => s.id === id);
        state.vehicleTypes.splice(index, 1);
    },
    setSpeedLimit(state, speedLimit) {
        state.speedLimit = speedLimit;
    },
    addSpeedLimit(state, speedLimit) {
        state.speedLimit.splice(0, 0, speedLimit);
    },
    setLoader(state, flag) {
        state.loader = flag;
    },
    updateSpeedLimit(state, body) {
        const index = state.speedLimit.findIndex((i) => i.id == body.id);
        state.speedLimit[index] = body;
        console.log('Speed ', state.speedLimit)
    },
    removeSpeedLimit(state, id) {
        state.speedLimit = state.speedLimit.filter((sl) => sl.id != id);
    },
    setUserRoles(state, data) {
        state.userRoles = data;
    },
    setUsers(state, users) {
        state.users = users;
    },
    addUser(state, user) {
        state.users.splice(0, 0, user);
    },
    updateUser(state, user) {
        const index = state.users.findIndex((i) => i.id == user.id);
        state.users[index] = user;
    },
    removeUser(state, id) {
        const index = state.users.findIndex((s) => s.id === id);
        state.users.splice(index, 1);
    },
    setVehicleUserMap(state, data) {
        state.vehicleUserMapData = data;
    },
    updateVehicleUserMap(state, mapDataArray) {
        mapDataArray.forEach((ele) => {
            const index = state.vehicleUserMapData.findIndex((s) => s.vehicleId === ele.vehicleId);
            if (index != -1) state.vehicleUserMapData.splice(index, 1, ele);
        });
    },
    setVehicleSpeedLimitColors(state, data) {
        state.vehicleSpeedLimitColors = data
    },
    updateVehicleSpeedLimitColors(state, obj) {
        state.vehicleSpeedLimitColors = state.vehicleSpeedLimitColors.map((color) => {
            if (color.id == obj.id) {
                return { ...obj }
            }
            return color;
        });
    },
    setSosCount(state, count) {
        state.sosCount = count;
    },
    getGeofenceCount(state,res){
        let geofenceArray= res.map((g,index)=>{
            return ({
                key:index,
                name:g.metadata.geofence.properties.geofenceName,
                geofenceID:g.geofenceID,
                inPremise:g.inPremise,
                inPremiseDevice:g.inPremiseDevice,
                outPremise:g.outPremise,
                outPremiseDevice:g.outPremiseDevice
             }) 
         })
         console.log("res",geofenceArray)
       state.geofenceCount = geofenceArray
     },
     setMapConnectionStatus(state,data){
         state.mapConnectionStatus=data;

     }
}
